// extracted by mini-css-extract-plugin
export default {"container":"loading_container__5Pm6l","loading":"loading_loading__Jtqt0","title":"loading_title__J6Nxd"};